module.exports = __webpack_public_path__ + "static/media/ner.4ba70d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ner.png
// module id = 323
// module chunks = 0